var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B4FB9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M5.562 10.6v9.7m3.3-9.7v9.2m0-9.2 4.5-7c1.5.4 2.4 1.8 2 3.1l-1.7 3.9h5.5c1.7 0 2.9 1 2.5 2.6l-1.5 5.8c-.3 1.4-2.4 1.4-2.4 1.4h-14m5.1-9.8h-5.1"
  })));
};
export { SvgLike as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiCmhlaWdodD0iMjQiCnZpZXdCb3g9IjAgMCAyNSAyNCIKZmlsbD0ibm9uZSIKeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgo+CjxwYXRoCiAgY2xhc3NOYW1lPSJzdHJva2UiCiAgZD0iTTUuNTYxNzcgMTAuNlYyMC4zTTguODYxNjkgMTAuNlYxOS44TTguODYxNjkgMTAuNkwxMy4zNjE3IDMuNjAwMDRDMTQuODYxNyA0LjAwMDA0IDE1Ljc2MTcgNS40MDAwMyAxNS4zNjE3IDYuNzAwMDNMMTMuNjYxNyAxMC42SDE5LjE2MTdDMjAuODYxNyAxMC42IDIyLjA2MTcgMTEuNiAyMS42NjE3IDEzLjJMMjAuMTYxNyAxOUMxOS44NjE3IDIwLjQgMTcuNzYxNyAyMC4zOTk5IDE3Ljc2MTcgMjAuMzk5OUgzLjc2MTcyTTguODYxNjkgMTAuNkgzLjc2MTcyIgogIHN0cm9rZT0iIzJCNEZCOSIKICBzdHJva2Utd2lkdGg9IjEuNSIKICBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCi8+Cjwvc3ZnPg==";